/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { AudienceTimelineComparisonWidget as AudienceTimelineComparisonWidgetType } from 'schemas/AudienceTimelineComparisonWidgetSchema'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import TopicsModeTimeline from '../../share/TopicsMode/Timeline'
import ComparisonModeTimeline from '../../share/ComparisonMode/Timeline'
import { TopicInfosEmptyGuard, WidgetLoadingGuard } from '../../../share/guards'
import ComparisonModeWidgetDataGuards from '../../share/ComparisonMode/guards/ComparisonModeWidgetDataGuards'
import TopicsModeWidgetDataGuards from '../../share/TopicsMode/guards/TopicsModeWidgetDataGuards'
import ComparisonModeWidgetSettingGuards from './guards/ComparisonModeWidgetSettingGuards'
import RunSearchCrosstabEffect from './searches/RunSearchCrosstabEffect'
import RunSearchTopicsEffect from './searches/RunSearchTopicsEffect'
import { isCrosstabMode } from '../utils'

const AudienceTimelineComparisonWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceTimelineComparisonWidgetType>(widgetId)

  if (isCrosstabMode(widgetSetting.comparisonMode!)) {
    return (
      <UnexpectedErrorBoundary>
        <ComparisonModeWidgetSettingGuards widgetId={widgetId}>
          <RunSearchCrosstabEffect widgetId={widgetId}>
            <WidgetLoadingGuard widgetId={widgetId}>
              <ComparisonModeWidgetDataGuards widgetId={widgetId}>
                <ComparisonModeTimeline widgetId={widgetId} />
              </ComparisonModeWidgetDataGuards>
            </WidgetLoadingGuard>
          </RunSearchCrosstabEffect>
        </ComparisonModeWidgetSettingGuards>
      </UnexpectedErrorBoundary>
    )
  }
  return (
    <UnexpectedErrorBoundary>
      <TopicInfosEmptyGuard widgetId={widgetId}>
        <RunSearchTopicsEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <TopicsModeWidgetDataGuards widgetId={widgetId}>
              <TopicsModeTimeline widgetId={widgetId} />
            </TopicsModeWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchTopicsEffect>
      </TopicInfosEmptyGuard>
    </UnexpectedErrorBoundary>
  )
}

export default AudienceTimelineComparisonWidget
